import { useEffect, useState } from 'react';

import { formatDecimals, handleInputDecimals } from './EditPrice/functions';

interface QuantityInputProps {
	value: number;
	decimals: number;
	onChange: (value: number) => void;
	className?: string;
}

export function QuantityInput({
	value,
	decimals,
	onChange,
	className,
}: QuantityInputProps) {
	const [display, setDisplay] = useState(formatDecimals(value, decimals));

	useEffect(() => {
		setDisplay(formatDecimals(value, decimals));
	}, [value, decimals]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const formatted = handleInputDecimals(e.target.value, decimals);
		setDisplay(formatted);
		const parsed = parseFloat(formatted.replace(/\./g, '').replace(',', '.'));
		if (!isNaN(parsed)) {
			onChange(parsed);
		}
	};

	return (
		<input
			type="text"
			inputMode="decimal"
			value={display}
			onChange={handleChange}
			onFocus={(e) => e.currentTarget.select()}
			className={className}
		/>
	);
}
